import React from 'react'

import { useSearchParam } from '../../../../hooks'
import { SupplierTable } from './SupplierTable'
import { Title } from './Title'

export const Suppliers: React.FC = () => {
  const [searchParam, setSearchParam] = useSearchParam('search')

  return (
    <>
      <Title
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />
      <SupplierTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />
    </>
  )
}
